import { useWBLang } from "./WBLanguageRuntimeProvider";

/**
 * On-site language switcher for the published website. Only renders when the
 * site has more than one language. Lists each available language by its native
 * display name (Intl.DisplayNames) and overrides browser detection on change.
 */
function displayName(code: string): string {
  try {
    const base = code.split("-")[0] || code;
    const dn = new Intl.DisplayNames([code], { type: "language" });
    return dn.of(base) ?? code;
  } catch {
    return code;
  }
}

export const LanguageSwitcher = () => {
  const { currentLang, availableLanguages, setCurrentLang } = useWBLang();

  if (availableLanguages.length <= 1) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[1000]">
      <label className="sr-only" htmlFor="wb-language-switcher">
        Language
      </label>
      <select
        id="wb-language-switcher"
        value={currentLang}
        onChange={(e) => setCurrentLang(e.target.value)}
        className="rounded-md border border-black/15 bg-white/95 px-3 py-1.5 text-sm shadow-sm backdrop-blur focus:outline-none focus:ring-2 focus:ring-black/20"
      >
        {availableLanguages.map((code) => (
          <option key={code} value={code}>
            {displayName(code)}
          </option>
        ))}
      </select>
    </div>
  );
};
